<main>
   <section style="padding-top: 140px;">
      <div class="container">
        <div class="row justify-center text-center">
          <div class="col-xl-6 col-lg-8 col-md-10">
            <div class="sectionTitle -md">
              <h2 class="sectionTitle__title">Yardım Merkezine Hoşgeldin</h2>
              <p class="sectionTitle__text mt-5 sm:mt-0">Sıkça Sorulan Soruları Buradan Bulabilirsin.</p>
            </div>
          </div>
        </div>

        <div class="row y-gap-30 pt-60 lg:pt-40">

          <div class="col-lg-4 col-md-6">
            <div class="bg-blue-1-05 rounded-4 px-50 py-40 h-full">
              <div class="size-70 bg-white rounded-full flex-center">
                <img src="assets/img/pages/help/icons/1.svg" alt="icon">
              </div>

              <div class="mt-24">
                <div class="text-18 fw-500">Rezervasyon Yapma</div>
                <p class="mt-5">Otel araması yapın, tarih ve misafir sayısını seçerek kolayca rezervasyon yapın.</p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="bg-blue-1-05 rounded-4 px-50 py-40 h-full">
              <div class="size-70 bg-white rounded-full flex-center">
                <img src="assets/img/pages/help/icons/2.svg" alt="icon">
              </div>

              <div class="mt-24">
                <div class="text-18 fw-500">Ödeme İşlemleri</div>
                <p class="mt-5">Güvenli ödeme altyapımız ile kredi kartı veya banka kartı ile ödeme yapın.</p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="bg-blue-1-05 rounded-4 px-50 py-40 h-full">
              <div class="size-70 bg-white rounded-full flex-center">
                <img src="assets/img/pages/help/icons/3.svg" alt="icon">
              </div>

              <div class="mt-24">
                <div class="text-18 fw-500">İptal ve İade</div>
                <p class="mt-5">Rezervasyon iptal ve iade koşulları otel politikasına göre değişir.</p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="bg-blue-1-05 rounded-4 px-50 py-40 h-full">
              <div class="size-70 bg-white rounded-full flex-center">
                <img src="assets/img/pages/help/icons/4.svg" alt="icon">
              </div>

              <div class="mt-24">
                <div class="text-18 fw-500">İndirim Kuponları</div>
                <p class="mt-5">Özel kampanya ve indirim kuponlarından yararlanmak için bültenimize abone olun.</p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="bg-blue-1-05 rounded-4 px-50 py-40 h-full">
              <div class="size-70 bg-white rounded-full flex-center">
                <img src="assets/img/pages/help/icons/5.svg" alt="icon">
              </div>

              <div class="mt-24">
                <div class="text-18 fw-500">Check-in / Check-out</div>
                <p class="mt-5">Giriş ve çıkış saatleri otelden otele farklılık gösterebilir. Detaylar için oteli kontrol edin.</p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="bg-blue-1-05 rounded-4 px-50 py-40 h-full">
              <div class="size-70 bg-white rounded-full flex-center">
                <img src="assets/img/pages/help/icons/6.svg" alt="icon">
              </div>

              <div class="mt-24">
                <div class="text-18 fw-500">Paket Tatiller</div>
                <p class="mt-5">Her şey dahil paketler, balayı ve aile tatilleri için özel fırsatlarımızı keşfedin.</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="layout-pt-lg layout-pb-lg">
      <div class="container">
        <div class="row justify-center text-center">
          <div class="col-auto">
            <div class="sectionTitle -md">
              <h2 class="sectionTitle__title">Sıkça Sorulan Sorular</h2>
              <p class="sectionTitle__text mt-5 sm:mt-0">En çok merak edilen soruların cevaplarını burada bulabilirsin.</p>
            </div>
          </div>
        </div>

        <div class="row y-gap-30 justify-center pt-40 sm:pt-20">
          <div class="col-xl-8 col-lg-10">
            <div class="accordion -simple row y-gap-20">

              @for (item of faqItems; track item.question; let i = $index) {
                <div class="col-12">
                  <div class="accordion__item px-20 py-20 border-light rounded-4" [class.is-active]="item.isOpen">
                    <div class="accordion__button d-flex items-center" (click)="toggleFaq(i)" style="cursor: pointer;">
                      <div class="accordion__icon size-40 flex-center bg-light-2 rounded-full mr-20">
                        <i class="icon-plus"></i>
                        <i class="icon-minus"></i>
                      </div>

                      <div class="button text-dark-1">{{ item.question }}</div>
                    </div>

                    <div class="accordion__content" [style.maxHeight]="item.isOpen ? '100%' : null">
                      <div class="pt-20 pl-60">
                        <p class="text-15">{{ item.answer }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              }

            </div>
          </div>
        </div>
      </div>
    </section>

    <app-newsletter></app-newsletter>
  </main>
